import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20cede25"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "position",
  id: "position",
  "infinite-scroll-distance": 400
}
const _hoisted_2 = {
  ref: "searchRef",
  style: {"width":"100%","background":"#f6f7f9","position":"sticky","top":"0px","z-index":"2"}
}
const _hoisted_3 = {
  key: 0,
  class: "w1400",
  style: {"padding":"20px 0 20px 0"}
}
const _hoisted_4 = { class: "w1400" }
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(['position-list', 'clear'])
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_z_header = _resolveComponent("z-header")!
  const _component_pc_banner = _resolveComponent("pc-banner")!
  const _component_z_search = _resolveComponent("z-search")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_z_position_clone = _resolveComponent("z-position-clone")!
  const _component_z_position_list = _resolveComponent("z-position-list")!
  const _component_z_qrcode = _resolveComponent("z-qrcode")!
  const _component_z_footer = _resolveComponent("z-footer")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_z_header),
    (!_ctx.isMyPage)
      ? (_openBlock(), _createBlock(_component_pc_banner, {
          key: 0,
          type: _ctx.type,
          num: 3,
          height: 90,
          ref: "swiperRef"
        }, null, 8, ["type"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isMyPage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_z_search, {
                      search: _ctx.search,
                      onInputChange: _ctx.handleInputChange
                    }, null, 8, ["search", "onInputChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, { gutter: 10 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: !_ctx.isMyPage ? 4 : 0
          }, {
            default: _withCtx(() => [
              (!_ctx.isMyPage)
                ? (_openBlock(), _createBlock(_component_z_position_clone, {
                    key: 0,
                    recruitType: _ctx.recruitType,
                    positionTypeIds: _ctx.positionTypeIds,
                    workPlaceIds: _ctx.workPlaceIds,
                    schoolObjects: _ctx.schoolObjects,
                    onFilterChange: _ctx.handleFilterChange
                  }, null, 8, ["recruitType", "positionTypeIds", "workPlaceIds", "schoolObjects", "onFilterChange"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["span"]),
          _createVNode(_component_el_col, {
            span: !_ctx.isMyPage ? 16 : 20
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_z_position_list, {
                  ref: "positionListRef",
                  list: _ctx.list,
                  hasNextPage: _ctx.hasNextPage,
                  type: _ctx.type,
                  class: _normalizeClass(['z-left']),
                  onLoading: _ctx.handleLoadingChange
                }, null, 8, ["list", "hasNextPage", "type", "onLoading"])
              ])
            ]),
            _: 1
          }, 8, ["span"]),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "qrCodeArea",
                ref: "qrCodeAreaRef",
                draggable: true,
                onDragstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDragStart && _ctx.handleDragStart(...args))),
                onDragend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDragEnd && _ctx.handleDragEnd(...args)))
              }, [
                _createVNode(_component_z_qrcode, { class: "qrcode" })
              ], 544)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_z_footer)
  ])), [
    [_directive_infinite_scroll, _ctx.handleLoad]
  ])
}